export default __webpack_public_path__ + "static/media/img-0645-north-macedonia-half-face.ec1ed015.png";